import { LoadingBone } from '@tableau/widgets';
import React from 'react';

const Notification = <div style={{ display: 'flex', marginBottom: 12, padding: 16 }} data-tb-test-id='notification-placeholder'>
  <LoadingBone style={{ width: 38, height: 38, borderRadius: 38 / 2, flexGrow: 0 }} />
  <div style={{ flexGrow: 1, marginLeft: 16 }}>
    <LoadingBone />
    <br />
    <LoadingBone />
    <LoadingBone />
  </div>
</div>;

export const NotificationLoader = () => {
  return <div style={{ padding: 8 }} >
    {Notification}
    {Notification}
    {Notification}
  </div>;
};
